import { MachineMaintenance } from 'models/MachineMaintenance';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'
import { push } from 'redux-first-history';

export const MachineMaintenanceActionType = {
    FETCH_MACHINEMAINTENANCES: 'FETCH_MACHINEMAINTENANCES',
    FETCH_MACHINEMAINTENANCES_SUCCESS: 'FETCH_MACHINEMAINTENANCES_SUCCESS',
    ADD_MACHINEMAINTENANCE: 'ADD_MACHINEMAINTENANCE',
    ADD_MACHINEMAINTENANCE_SUCCESS: 'ADD_MACHINEMAINTENANCE_SUCCESS',
    EDIT_MACHINEMAINTENANCE: 'EDIT_MACHINEMAINTENANCE',
    EDIT_MACHINEMAINTENANCE_SUCCESS: 'EDIT_MACHINEMAINTENANCE_SUCCESS',
    DELETE_MACHINEMAINTENANCE: 'DELETE_MACHINEMAINTENANCE',
    DELETE_MACHINEMAINTENANCE_SUCCESS: 'DELETE_MACHINEMAINTENANCE_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchMachineMaintenancesAction {
    type: typeof MachineMaintenanceActionType.FETCH_MACHINEMAINTENANCES
    payload: ApiPayload,
    returnPayload: MachineMaintenance[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddMachineMaintenancesAction {
    type: typeof MachineMaintenanceActionType.ADD_MACHINEMAINTENANCE
    payload: ApiPayload,
    returnPayload: MachineMaintenance,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteMachineMaintenancesAction {
    type: typeof MachineMaintenanceActionType.DELETE_MACHINEMAINTENANCE
    payload: ApiPayload,
    returnPayload: MachineMaintenance,
    meta: {
        isApiCall: boolean
    },
}

export type IMachineMaintenanceActions = IFetchMachineMaintenancesAction | IAddMachineMaintenancesAction | IDeleteMachineMaintenancesAction

const baseUrl = 'api/machineMaintenances';
export class MachineMaintenanceActions {
    public static fetchMachineMaintenances(token: string): IMachineMaintenanceActions {
        return {
            type: MachineMaintenanceActionType.FETCH_MACHINEMAINTENANCES,
            payload: Api.fetchApiCall(baseUrl, token, MachineMaintenanceActionType.FETCH_MACHINEMAINTENANCES_SUCCESS, MachineMaintenanceActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addMachineMaintenance(token: string, machineMaintenance: MachineMaintenance): IMachineMaintenanceActions {
        return {
            type: MachineMaintenanceActionType.ADD_MACHINEMAINTENANCE,
            payload: Api.postApiCall(baseUrl, token, MachineMaintenanceActionType.ADD_MACHINEMAINTENANCE_SUCCESS, MachineMaintenanceActionType.API_ERROR, machineMaintenance, true),
            returnPayload: MachineMaintenance.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editMachineMaintenance(token: string, machineMaintenance: MachineMaintenance): IMachineMaintenanceActions {
        return {
            type: MachineMaintenanceActionType.EDIT_MACHINEMAINTENANCE,
            payload: Api.putApiCall(baseUrl + '/' + machineMaintenance.id, token, MachineMaintenanceActionType.EDIT_MACHINEMAINTENANCE_SUCCESS, MachineMaintenanceActionType.API_ERROR, machineMaintenance, true),
            returnPayload: MachineMaintenance.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteMachineMaintenance(token: string, id: number): IMachineMaintenanceActions {
        return {
            type: MachineMaintenanceActionType.DELETE_MACHINEMAINTENANCE,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, MachineMaintenanceActionType.DELETE_MACHINEMAINTENANCE_SUCCESS, MachineMaintenanceActionType.API_ERROR, true),
            returnPayload: MachineMaintenance.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static moveToAddMachineMaintenance() {
        return push('/MachineMaintenances/add')
    }

    public static moveToEditMachineMaintenance(id: number) {
        return push('/MachineMaintenances/edit/' + id)
    }

    public static moveToMachineMaintenances() {
        return push('/MachineMaintenances')
    }
}
